import { Link } from "react-router-dom";
import { heroBg, heroCover } from "@/mocks/manga";

const stats = [
  { value: "13", label: "单行本全卷" },
  { value: "100+", label: "连载与章节" },
  { value: "全彩", label: "珍藏版本" },
  { value: "番外", label: "完整收录" },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="甜蜜惩罚漫画浪漫背景插画" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/60 to-background-50"></div>
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-28 md:px-6 md:pt-36 lg:grid-cols-2 lg:gap-8 lg:pb-20">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-heart-3-line text-sm"></i>
            单行本全卷 · 连载话 · 全彩版本 · 番外收录
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-5xl">
            甜蜜惩罚漫画
            <span className="mt-1 block text-2xl text-primary-600 md:text-4xl">单行本全卷完整阅读</span>
          </h1>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            甜蜜惩罚漫画网专注整理《甜蜜惩罚》漫画的完整目录，按单行本卷与话数清晰分类，
            全彩版本与番外一并收录，让你从第1卷到完结卷、从正篇到番外，轻轻松松找齐整部作品。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/catalog"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              开始阅读
              <i className="ri-book-open-line text-base"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 bg-background-50/70 px-7 py-3 text-sm font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              了解这部作品
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl bg-background-50/80 px-3 py-3 text-center">
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-heading text-xl font-bold text-primary-600 md:text-2xl">{s.value}</dd>
                <dd className="mt-0.5 text-xs text-foreground-600">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative mx-auto w-full max-w-xs md:max-w-sm">
          <div className="pointer-events-none absolute -right-6 -top-6 h-32 w-32 rounded-full bg-accent-200/50 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-6 -left-6 h-32 w-32 rounded-full bg-primary-200/50 blur-2xl"></div>
          <div className="relative overflow-hidden rounded-2xl shadow-lg ring-1 ring-background-200/70">
            <img src={heroCover} alt="甜蜜惩罚漫画第1卷封面插画" className="aspect-[3/4] w-full object-cover object-top" />
          </div>
          <div className="absolute -left-4 top-8 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-semibold text-background-50 shadow-md">
            全彩收录
          </div>
          <div className="absolute -right-3 bottom-10 rounded-full bg-primary-500 px-4 py-1.5 text-xs font-semibold text-background-50 shadow-md">
            番外齐全
          </div>
        </div>
      </div>
    </section>
  );
}